import LockerType from 'src/models/locker/LockerType'
import WorkflowActivationPeriod from 'src/models/workflow/WorkflowActivationPeriod'
import PeriodConfiguration from './PeriodConfiguration'
import RentalWorkflowConfigurationJson from './interfaces/RentalWorkflowConfigurationJson'
import LockerSize from '../../locker/LockerSize'
import LockerSizeJson from '../../locker/interfaces/LockerSizeJson'
import LockerTypeWithSize, {
  LockerTypeWithSizeMatcher,
} from 'src/models/locker/LockerTypeWithSize'

export default class RentalWorkflowConfiguration {
  workflowActivationPeriod: WorkflowActivationPeriod
  lockerTypes: Array<LockerType>
  periodConfiguration: PeriodConfiguration
  lockerSizes: Array<LockerSize>
  skipLockerTypeSelectionIfOnlyOneLockerType: boolean

  constructor(
    workflowActivationPeriod: WorkflowActivationPeriod,
    lockerTypes: Array<LockerType>,
    periodConfiguration: PeriodConfiguration,
    lockerSizes: Array<LockerSize>,
    skipLockerTypeSelectionIfOnlyOneLockerType: boolean,
  ) {
    this.workflowActivationPeriod = workflowActivationPeriod
    this.lockerTypes = lockerTypes
    this.periodConfiguration = periodConfiguration
    this.lockerSizes = lockerSizes
    this.skipLockerTypeSelectionIfOnlyOneLockerType =
      skipLockerTypeSelectionIfOnlyOneLockerType
  }

  getLockerTypesWithSizeSorted(): Array<LockerTypeWithSize> {
    return LockerTypeWithSizeMatcher(this.lockerTypes, this.lockerSizes)
  }

  getLockerSizeForLockerType(lockerType: LockerType) {
    return this.lockerSizes.find((lockerSize: LockerSize) =>
      lockerSize.types.includes(lockerType.id),
    )
  }

  static fromJson(data: RentalWorkflowConfigurationJson) {
    return new this(
      WorkflowActivationPeriod.fromJson(data.workflowActivationPeriod),
      data.lockerTypes.map((item) => LockerType.fromJson(item)),
      PeriodConfiguration.fromJson(data.periodConfiguration),
      data.lockerSizes.map((item: LockerSizeJson) => LockerSize.fromJson(item)),
      data.skipLockerTypeSelectionIfOnlyOneLockerType,
    )
  }
}
